module.exports = __webpack_public_path__ + "img/msg2.4ce943d1.png";